import { useTheme } from 'styled-components';

import i18n, { AppLangs } from '../i18n';
import { ConfigProvider } from '../utils/local-antd';

type AntdConfigProps = {
  children: React.ReactNode;
};

export const AntdConfig: React.FC<AntdConfigProps> = ({ children }) => {
  const theme = useTheme();
  const currentLanguage = i18n.language;

  return (
    <ConfigProvider
      direction={currentLanguage === AppLangs.AR ? 'rtl' : 'ltr'}
      theme={{
        token: {
          fontFamily: "'Roboto', 'Zain', sans-serif",
          colorPrimary: theme.main,
        },
        components: {
          Menu: {
            darkItemSelectedBg: theme.sub,
            darkItemSelectedColor: `${theme.lightMain} !important`,
            darkItemHoverBg: theme.lightMain,
          },
          Tabs: {
            inkBarColor: theme.black,
            itemActiveColor: `${theme.black} !important`,
            fontWeightStrong: 700,
            itemHoverColor: 'green !important',
            itemColor: `${theme.red} !important`,
            itemSelectedColor: `${theme.main} !important`,
          },
          Steps: {
            navArrowColor: theme.main,
          },
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
};
